import {Link} from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import Logo from '../images/logo@2x.png';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false
    }
  }
  handleModalOpen = event => {
    //console.log('handleModalOpen: ', event);
    this.setState({isModalOpen: !this.state.isModalOpen})
  }

  handleModalClose = event => {
    if (this.state.isModalOpen) {
      this.setState({isModalOpen: false})
    }
  }

  render() {
    return (

      <header id="masthead" className="container">
        <nav className="navbar" role="navigation" aria-label="main navigation">
          <div className="navbar-brand">
            <Link className="navbar-item" to="/" onClick={() =>this.handleModalClose()}>
              <img src={Logo} width="112" height="28"/>
            </Link>

            <a role="button" className="navbar-burger burger" aria-label="menu" aria-expanded="false" onClick={() => this.handleModalOpen()}>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </a>
          </div>

          <div id="navbarBasicExample" className={this.state.isModalOpen ? "navbar-menu is-active" : "navbar-menu"} onClick={() =>this.handleModalClose()}>
            <div className="navbar-start"></div>

            <div className="navbar-end">
              <Link to="/about" className="navbar-item">
                About
              </Link>
              <div className="navbar-item has-dropdown is-hoverable">
                <a className="navbar-link is-arrowless">
                  For Candidates
                </a>

                <div className="navbar-dropdown">
                  <Link to="career-advice" className="navbar-item">
                    Career Advice
                  </Link>
                  <Link to="resume-creation" className="navbar-item">
                    Resume Creation
                  </Link>
                  <Link to="interview-coaching" className="navbar-item">
                    Interview Coaching
                  </Link>
                  <Link to="relocation" className="navbar-item">
                    Relocation
                  </Link>
                  <hr className="navbar-divider"/>
                  <Link to="open-positions" className="navbar-item">
                    Open Positions
                  </Link>
                </div>
              </div>
              <div className="navbar-item has-dropdown is-hoverable">
                <a className="navbar-link is-arrowless">
                  Recruitment Business
                </a>

                <div className="navbar-dropdown">
                  <Link to="recruitment-services" className="navbar-item">
                    Recruitment Services
                  </Link>
                  <Link to="training" className="navbar-item">
                    Training
                  </Link>
                  <Link to="advisory" className="navbar-item">
                    Advisory
                  </Link>

                </div>
              </div>
              <Link to="events" className="navbar-item">
                Events
              </Link>
              <Link to="podcasts" className="navbar-item">
                Podcast
              </Link>
              <Link to="blog" className="navbar-item">
                Blog
              </Link>
            </div>
          </div>
        </nav>
      </header>
    )
  }
}

Header.propTypes = {
  siteTitle: PropTypes.string
}

Header.defaultProps = {
  siteTitle: ``
}

export default Header
